import styles from './SubCopy.module.scss';

export type Props = {
  copy?: string;
};

const TEXT = `It might be temporarily out of stock. Try a more generic search term or try looking for alternative products within the departments.`;

const SubCopy = ({ copy = TEXT }: Props) => (
  <div data-testid="component-sub-copy" className={styles['sub-copy']}>
    <p data-testid="sub-copy-copy" className={styles['sub-copy__copy']}>
      {copy}
    </p>
  </div>
);

export default SubCopy;
